export default "__VITE_ASSET__72UvhUs6__"